<section class="py-4">
  <div class="container">
    <div class="row">

    </div>
    <div class="row" *ngIf="entryInfo">
      <div class="col-12">
        <div class="entry-details-minimal">
          <div class="entry-details-header">Entry Details</div>
          <div class="entry-details-row">
            <span class="entry-details-label">Entry:</span>
            <span class="entry-details-value">{{ entryInfo.entry }}</span>
          </div>
          <div class="entry-details-row">
            <span class="entry-details-label">Horse:</span>
            <span class="entry-details-value">
              <a [href]="'/horse-profile/' + (isUS ? 'us_' : '') + entryInfo.id_caballo">
                {{ entryInfo.horseName }}
              </a>
            </span>
          </div>
          <div class="entry-details-row">
            <span class="entry-details-label">Riders:</span>
            <span class="entry-details-value">{{ entryInfo.riderName }}</span>
          </div>
          <div class="entry-details-row">
            <span class="entry-details-label">Owner:</span>
            <span class="entry-details-value">{{ entryInfo.owner }}</span>
          </div>
          <div class="entry-details-row">
            <span class="entry-details-label">Trainer:</span>
            <span class="entry-details-value">
              <a [href]="'/trainer-profile/'+ showId + '/' + (isUS ? 'us_' : '') + entryInfo.id_entrenador">
                {{ entryInfo.trainerName }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="classes.length > 0" class="row">
      <table class="table registered-classes-table mb-4">
        <thead>
          <tr>
            <th colspan="7" class="registered-classes-header">Registered Classes</th>
          </tr>
          <tr class="registered-classes-columns">
            <th>NUMBER</th>
            <th>NAME</th>
            <th>RIDER</th>
            <th>RANK</th>
            <th>RING</th>
            <th>DAY</th>
            <th>EST. START</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let class of classes">
            <td>{{ class.ClassNumber || '-' }}</td>
            <td>
              {{ class.nombre || class.ClassName || '-' }}
            </td>
            <td>
              <a [href]="'/profile/' + class.id_persona + '/' + showId">
                {{ class.Rider || '-' }}
              </a>
            </td>
            <td>{{ class.Rank || '-' }}</td>
            <td>{{ class.Ring || '-' }}</td>
            <td>
              {{ class.Date ? (class.Date | date:'MM/dd/yy') : '-' }}
            </td>
            <td>
              {{ class.Date ? (class.Date | date:'shortTime') : '-' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
